import { Button } from "../../shared/button";

export function CourseName(props: { header: string }) {
  return (
    <a href={`#${props.header}`}>
      <Button key={props.header} className="CourseCardsHeaderButtons">
        {props.header}
      </Button>
    </a>
  );
}
